import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { endpoints } from '@rossum/api-client';
import { PatchSavedViewPayload } from '@rossum/api-client/savedViews';
import { useApiClient } from '../../../lib/apiClient';
import { notify } from '../../toaster';
import { GET_SAVED_VIEWS_QUERY } from './useGetSavedViews';

type UpdateSavedViewVariables = {
  savedViewId: number;
  payload: PatchSavedViewPayload;
};

export const useUpdateSavedView = () => {
  const api = useApiClient();
  const queryClient = useQueryClient();
  const intl = useIntl();

  return useMutation({
    mutationFn: ({ savedViewId, payload }: UpdateSavedViewVariables) =>
      api.request(endpoints.savedViews.patch(savedViewId, payload)),
    onSuccess: updatedView => {
      queryClient.invalidateQueries({ queryKey: [GET_SAVED_VIEWS_QUERY] });
      notify.default({
        title: intl.formatMessage(
          { id: 'containers.savedViews.drawer.notifications.updated' },
          { viewName: updatedView.name }
        ),
      });
    },
    onError: () => {
      notify.error({
        title: intl.formatMessage({
          id: 'containers.savedViews.drawer.notifications.error',
        }),
      });
    },
  });
};
